<template>
    <Snowf
    :amount="amount"
    :size="size"
    :speed="speed"
    :wind="wind"
    :opacity="opacity"
    :swing="swing"
    :image="null"
    :zIndex="null"
    :resize="true"
    :color="color"/>

</template>

<script>
import Snowf from 'vue-snowf';
export default {
    name:'SnowComponent',
    components: {
        Snowf
    },
    props: {
        amount: { type: Number, default: 100 },
        size: { type: Number, default: 3 },
        speed: { type: Number, default: 1 },
        wind: { type: Number, default: 0 },
        opacity: { type: Number, default: 0.8 },
        swing: { type: Number, default: 1 },
        sizeOptions: { type: Array, default: ()=>([1,2,3,4,5])},
        speedOptions: { type: Array, default: ()=>([0.5,1,1.5,2,2.5,3,3.5,4])},
        windOptions: { type: Array, default: ()=>([0,-5,-4,-3,-2,-1,0,1,2,3,4,5,0])},
        opacityOptions: { type: Array, default: ()=>([0.8,0,0.5,0.6,0.7,0.8])},
        swingOptions: { type: Array, default: ()=>([1,0,1])},
        color: { type: String, default: "#fff"}
    },
    timers: {
        storm: { time: 15000, autostart: true, repeat:true }
    },
    methods:{
        storm() {
            //this.snow.amount = this.ramdomNumber(1000)
            const data = {
                size: this.sizeOptions[this.ramdomNumber(this.sizeOptions.length)],
                speed: this.speedOptions[this.ramdomNumber(this.speedOptions.length)],
                wind: this.windOptions[this.ramdomNumber(this.windOptions.length)],
                opacity: this.opacityOptions[this.ramdomNumber(this.opacityOptions.length)],
                swing: this.swingOptions[this.ramdomNumber(this.swingOptions.length)]                
            }
            this.$emit('changeOptions', data)
        },
        ramdomNumber(limit) {
            return Math.round(Math.random() * limit)
        }
    }
}
</script>

<style>

</style>